import Container = PIXI.Container;
import Point = PIXI.Point;
import Sprite = PIXI.Sprite;
import { createDonut, createSprite, setScaleByReference, vibrate } from '../../utils/GameEngine';
import { clearAnimations } from '../../utils/Animations';
import { Donut } from './Donut';
import { CoreGameplay } from './CoreGameplay';
import { getRandomFromInterval } from '../../utils/MathUtils';
import { Events } from '../Events';

export class Stack extends Container {
    private donuts: Donut[] = [];
    public index: number;
    public selectedDonut: Donut;
    private donutDistance: number;
    private donutScale: number;
    public clicked: boolean;
    private lastScoredHeight: number = 0;
    private underlay: Container;
    private overlay: Container;
    private donutContainer: Container;
    private overlayTop: PIXI.Sprite;
    private timeout: any;

    constructor(
        private core: CoreGameplay,
        private origin: PIXI.Point,
        private color: string,
        private stackHeight: number,
        private freeInThisStack: number,
        availableSpace: number
    ) {
        super();
        this.underlay = new Container();
        this.overlay = new Container();
        this.donutContainer = new Container();
        this.addChild(this.underlay, this.donutContainer, this.overlay);
        for (let i: number = 0; i < stackHeight - freeInThisStack; i++) {
            const finalColor: string = this.getDonutVariant(color);
            const donut: Donut = createDonut(this.getDonutVariant(color), this.donutContainer);
            donut.visible = false;
            let scaleFactor: number = 0.7;
            if (availableSpace > 264) { // adica mai sunt mai putin de 4 stackuri
                scaleFactor = 0.6;
            }
            if (!this.donutScale) {
                this.donutScale = availableSpace * scaleFactor / donut.width;
            }
            const plusOrMinus: number = Math.random() < 0.5 ? -1 : 1;
            donut.scale.set(plusOrMinus * this.donutScale, this.donutScale);
            donut.initialScale = new Point(plusOrMinus * this.donutScale, this.donutScale);
            if (!this.donutDistance) {
                this.donutDistance = donut.height * 0.45;
            }
            donut.anchor.set(0.5, 0.5);
            donut.y = this.origin.y + i * -this.donutDistance;
            donut.x = this.origin.x;
            this.donuts.push(donut);
        }

        this.enableClicks();
        this
            .on('pointerdown', this.onClick.bind(this))
            .on('pointerup', this.onPointerUp.bind(this))
            .on('pointerupoutside', (): void => {
                this.clicked = false;
            });
        this.addUnderlay();
    }

    private addUnderlay(): void {
        const lastDonut: Donut = this.donuts[0];

        const underlayBot: Sprite = createSprite('underlay-bottom', this.underlay);
        underlayBot.anchor.set(0.5, 0.5);
        setScaleByReference(underlayBot, lastDonut);
        underlayBot.scale.set(underlayBot.scale.x * 1.15, underlayBot.scale.y * 1.15);
        underlayBot.position.set(this.origin.x, this.origin.y + 20);
        underlayBot.alpha = 0.5;

        const underlayTop: Sprite = createSprite('underlay-top', this.underlay);
        underlayTop.anchor.set(0.5, 0.5);
        underlayTop.scale.set(underlayBot.scale.x, underlayBot.scale.y);
        underlayTop.position.set(this.origin.x, this.origin.y - this.stackHeight * this.donutDistance);
        underlayTop.alpha = 0.5;

        const underlayMid: Sprite = createSprite('underlay-middle', this.underlay);
        underlayMid.anchor.set(0.5, 1);
        underlayMid.scale.x = underlayBot.scale.x;
        underlayMid.position.set(this.origin.x, underlayBot.y - underlayBot.height / 2);
        underlayMid.height = underlayMid.y - underlayTop.y - underlayTop.height / 2;
        underlayMid.alpha = 0.5;

        this.overlayTop = createSprite('overlay-top', this.overlay);
        this.overlayTop.anchor.set(0.5, 0.5);
        this.overlayTop.scale.set(underlayBot.scale.x, underlayBot.scale.y);
        this.overlayTop.position.set(this.origin.x, underlayTop.y + underlayTop.height / 2);
        this.overlayTop.alpha = 0.5;

        const overlayMid: Sprite = createSprite('overlay-lights', this.overlay);
        overlayMid.anchor.set(0.5, 1);
        overlayMid.scale.x = underlayBot.scale.x;
        overlayMid.position.set(this.origin.x, underlayMid.y);
        overlayMid.height = underlayMid.height - this.overlayTop.height / 2;
        overlayMid.alpha = 0.5;
    }

    private onClick(): void {
        this.clicked = true;
        dispatchEvent(new CustomEvent(Events.userInput));
        // this.timeout = setTimeout(
        //   (): void => {
        //     this.
        //   },
        //   100);
        // this.core.onDragStart(this.index);
    }

    private onPointerUp(): void {
        if (this.clicked) {
            this.core.onStackPointerUp(this.index);
        } else {
            this.core.onDragEnd(this.index);
        }
    }

    public deselect(): void {
        this.clicked = false;
        clearAnimations(this.selectedDonut);
        this.selectedDonut.y = this.selectedDonut.beforeSelectPos.y;
        const plusOrMinus: number = Math.random() < 0.5 ? -1 : 1;
        this.selectedDonut.scale.set(this.selectedDonut.initialScale.x, this.selectedDonut.initialScale.y);
        this.selectedDonut = null;
    }

    public selectDonut(quick: boolean): void {
        this.selectedDonut = this.donuts[this.donuts.length - 1];
        this.selectedDonut.beforeSelectPos = new Point(this.selectedDonut.x, this.selectedDonut.y);
        TweenLite.to(this.selectedDonut, 0.1, {
            y: this.overlayTop.y - this.overlayTop.height / 2 - this.selectedDonut.height / 2 - 5
        });
        if (!quick) {
            this.playIdleAnimation();
        }
        // SoundManager.getInstance().playSound('interact');
    }

    public popDonut(): Donut {
        const donut: Donut = this.donuts.pop();
        // this.updateMask();
        return donut;
    }

    public pushDonut(donutToMove: Donut, quick: boolean = false): void {
        this.donutContainer.addChild(donutToMove);
        // this.addChild(this.stick);
        this.donuts.push(donutToMove);
        // this.updateMask();
        if (this.sameColor() && !quick) {
            this.playWinAnimation();
        }
    }

    private playIdleAnimation(): void {
        TweenMax.to(this.selectedDonut, 0.5, {
            rotation: '+=0.1',
            yoyo: true,
            repeat: -1,
            delay: 0.1,
            ease: Elastic.easeOut
        });
        TweenMax.to(this.selectedDonut, 0.5, {
            rotation: '-=0.1',
            yoyo: true,
            repeat: -1,
            delay: 0,
            ease: Elastic.easeOut
        });
        TweenMax.to(this.selectedDonut.scale, 0.5, {
            x: this.selectedDonut.scale.x * 1.1,
            y: this.selectedDonut.scale.y * 1.1,
            yoyo: true,
            repeat: -1,
        });
    }

    public hasDonuts(): boolean {
        return this.donuts.length > 0;
    }

    public hasSpace(): boolean {
        return this.donuts.length < this.stackHeight;
    }

    public getDestinationPoint(): Point {
        if (this.donuts.length > 0) {
            const lastDonut: Sprite = this.donuts[this.donuts.length - 1];
            return new Point(lastDonut.x, lastDonut.y - this.donutDistance);
        } else {
            return this.origin;
        }
    }

    public disableClicks(): void {
        this.interactive = false;
        this.buttonMode = false;
    }

    public enableClicks(): void {
        this.interactive = true;
        this.buttonMode = true;
    }

    public sameColor(): boolean {
        let sameColor: boolean = true;
        let color: string;
        let totalOfColor: number;
        this.donuts.forEach((donut: Donut): void => {
            if (!color) {
                color = donut.color.split('_')[0];
                totalOfColor = this.core.getTotalOfColor(color);
            } else {
                if (donut.color.split('_')[0] !== color) {
                    sameColor = false;
                }
            }
        });
        return sameColor && this.donuts.length === totalOfColor;
    }

    public playNoAnimation(): void {
        TweenMax.to(this, 0.05, {x: '+=5', yoyo: true, repeat: 3});
    }

    public playWinAnimation(): void {
        this.donuts.forEach((donut: Donut, index: number): void => {
            TweenMax.to(donut, 0.1, {
                y: '-=20',
                yoyo: true,
                repeat: 1,
                delay: index * 0.1,
                ease: Power0.easeIn,
            });
        });
        vibrate(200);
    }

    private getDonutVariant(color: string): string {
        const variants: any = {
            red: 1,
            blue: 2,
            green: 2,
            orange: 2,
            cyan: 2,
            pink: 2,
            white: 2,
            choco: 2,
            caramel: 1,
            zebra: 1,
            sprinkles: 2,
        };
        const variant: number = getRandomFromInterval(1, variants[color]);
        return color + '_' + variant;
    }

    public toScore(): number {
        let sameColor: boolean = true;
        let color: string;
        let totalOfColor: number;
        let score: number = 0;
        this.donuts.forEach((donut: Donut): void => {
            if (!color) {
                color = donut.color.split('_')[0];
                totalOfColor = this.core.getTotalOfColor(color);
            } else {
                if (donut.color.split('_')[0] !== color) {
                    sameColor = false;
                }
            }
        });
        if (sameColor && this.lastScoredHeight < this.donuts.length) {
            if (this.donuts.length === totalOfColor) {
                score = 500;
            } else {
                score = 100;
            }
            this.lastScoredHeight = this.donuts.length;
        }
        return score;
    }

    public playInitAnimation(onAnimationComplete?: () => any): void {
        if (this.donuts.length === 0 && onAnimationComplete) {
            onAnimationComplete();
        }
        this.donuts.forEach((donut: Donut, index: number): void => {
            donut.visible = true;
            donut.beforeSelectPos = donut.position.clone();
            donut.y = -80;
            TweenLite.to(donut, 0.2, {
                y: donut.beforeSelectPos.y,
                ease: Back.easeIn,
                onComplete: (): void => {
                    TweenMax.from(donut.scale, 0.2, {
                        x: donut.scale.x * 1.2,
                        y: donut.scale.y * 0.6,
                        ease: Back.easeOut,
                        yoyo: true
                    });
                    if (index === this.donuts.length - 1) {
                        if (onAnimationComplete) {
                            onAnimationComplete();
                        }
                    }
                },
                delay: index * 0.1
            });
        });
    }

    public getOrigin(): Point {
        return this.origin;
    }
}